// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3307":"423deffb","3625":"423deffb","6773":"423deffb","7934":"423deffb","8498":"423deffb"}[chunkId] + ".chunk.css";
};